import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import * as DataService from '../service/data-info-chart/requestsUtil'
import { BUSINESS_UNIT } from '../utils/constants'


class RoutesList extends Component {

  constructor(props) {
    super(props);
    this.productsLoop = this.productsLoop.bind(this);
    this.state = {profileHome: this.props.profileHome, places:[]}
  }

  componentDidMount() {
    $('.sidebar-nav ul .has-child .child-menu').hide();
    $('.sidebar-nav ul .has-child > a').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next('.child-menu').slideToggle(300);
    });
    DataService.getFetch(BUSINESS_UNIT)
      .then((data) => { this.setState({places: data, loaded: true}) })
  }

  productsLoop() {
    return this.state.places.map((place) => {
      return (
        <li key={place.id}><Link to={{pathname: this.props.profile + place.name, state: {kpi: place.kpi, kpiMonitor: place.kpiMonitor, kpiStrategy: place.kpiStrategy}}}>{place.name}</Link></li>
      );
    });
  }

  render() {
    return (
      <div className="sidebar-nav">
        <ul>
          <li className="has-child">
            <a href=""><span className="material-icons">folder</span>Unidades de Negocio</a>
            <ul className="child-menu">
              {this.productsLoop()}
            </ul>
          </li>
          <li className="close-sesion"><Link to={"/"}><span>Cerrar Sesión</span></Link></li>
        </ul>
      </div>
    );
  }
}

export default RoutesList;



// WEBPACK FOOTER //
// ./src/routers/routesList.js